import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { useSpeedIndex } from "./useSpeedIndex";
import { useSpeedIndexOptions } from "./useSpeedIndexOptions";

const id = "dealer-tire-speed-index-panel";

export const TireSpeedIndexFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const [, { toggle }] = useSpeedIndex();

  const options = useSpeedIndexOptions();

  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.tireSpeedIndex")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, count, tireSpeedIndex }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={tireSpeedIndex}
        >
          <Checkbox
            onChange={(): void => {
              toggle([tireSpeedIndex]);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            disabled={count === 0}
            name="tireSpeedIndex"
          />
          <span className="flex-1">{tireSpeedIndex}</span>
        </label>
      ))}
    </Collapsible>
  );
};
